interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "SLL";
};

const SLL: Currency = Object.freeze({
  "displayName": "Sierra Leonean Leone",
  "numericCode": 694,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "SLL",
  "symbol": "Le"
});

export { SLL };
